import React, { useCallback, useMemo } from 'react';
import { useParams, withRouter } from 'react-router-dom';
import { CatalogForm } from '../../../../components/CatalogForm/CatalogForm';
import { ClienteService } from '../../../../services/ClienteService';

export const ClienteEstadistico = ({ match, id: propId, onSave }) => {
  const routeParams = useParams() || {};
  const clientId = propId || match?.params?.id || routeParams?.id;

  const loadClientData = useCallback(async () => {
    if (!clientId) return null;
    try {
      const data = await ClienteService.obtenerDetalleCompleto(clientId);
      if (!data) return null;

      return {
        cliente_saldo_actual: data.cliente_saldo_actual !== undefined && data.cliente_saldo_actual !== null ? String(data.cliente_saldo_actual) : '0.00',
        cliente_acumulado_actual: data.cliente_acumulado_actual !== undefined && data.cliente_acumulado_actual !== null ? String(data.cliente_acumulado_actual) : '0.00',
        cliente_ultimo_envio: data.cliente_ultimo_envio ? String(data.cliente_ultimo_envio).substring(0, 10) : '',
        cliente_ultimo_pago: data.cliente_ultimo_pago ? String(data.cliente_ultimo_pago).substring(0, 10) : '',
      };
    } catch (e) {
      console.error('Error al cargar datos estadísticos', e);
      return null;
    }
  }, [clientId]);

  const fields = useMemo(
    () => [
      {
        name: 'section_estadisticas',
        label: 'Métricas Financieras y de Operación',
        type: 'section',
        col: 12,
      },
      {
        name: 'cliente_saldo_actual',
        label: 'Saldo Actual ($)',
        type: 'number',
        col: 6,
        placeholder: '$0.00',
        helperText: 'Saldo pendiente acumulado a la fecha',
      },
      {
        name: 'cliente_acumulado_actual',
        label: 'Acumulado de Consumo Anual ($)',
        type: 'number',
        col: 6,
        placeholder: '$0.00',
        helperText: 'Consumo total registrado en el ejercicio actual',
      },
      {
        name: 'cliente_ultimo_envio',
        label: 'Fecha de Último Envío / Embarque',
        type: 'date',
        col: 6,
      },
      {
        name: 'cliente_ultimo_pago',
        label: 'Fecha de Último Pago Recibido',
        type: 'date',
        col: 6,
      },
    ],
    []
  );

  const handleSubmit = useCallback(
    async (values) => {
      const payload = {
        id: clientId,
        ...values,
      };
      return await ClienteService.guardar(payload);
    },
    [clientId]
  );

  const handleSuccess = useCallback(
    (response) => {
      if (onSave) {
        onSave(response);
      }
    },
    [onSave]
  );

  return (
    <div className="space-y-6">
      <CatalogForm
        title="Datos Estadísticos y Métricas"
        subtitle="Saldos, consumos y fechas de última actividad del cliente"
        fields={fields}
        id={clientId}
        loadData={loadClientData}
        onSubmit={handleSubmit}
        onSuccess={handleSuccess}
        submitButtonText="Guardar Métricas"
      />
    </div>
  );
};

export default withRouter(ClienteEstadistico);
